import {
    Component,
    OnInit,
    Input,
    AfterViewInit,
    Output,
    EventEmitter,
    OnChanges,
    SimpleChanges,
    OnDestroy,
    ElementRef,
  } from '@angular/core';
  import Map from 'ol/Map';
  import View from 'ol/View';
  import OSM from 'ol/source/OSM';
  import * as olProj from 'ol/proj';
  import TileLayer from 'ol/layer/Tile';
  import MousePosition from 'ol/control/MousePosition';
  import { createStringXY } from 'ol/coordinate';
  import {
    DragRotateAndZoom,
    defaults as defaultInteractions,
  } from 'ol/interaction';
  import axios from 'src/app/Service/axios';
  import { NotificationService } from 'src/app/Service/notification.service';
  import { ActivatedRoute, Router } from '@angular/router';
  import { OtherService } from 'src/app/Service/other.service';
  import { MapService } from 'src/app/Service/map.service';
import { Location } from '@angular/common';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';

  declare let $: any;
  

@Component({
  selector: 'lcation',
  templateUrl: './location.component.html',
})
export class LocationComponent implements OnInit {
  map: any = {};
  car: any;
  Id:number=0;
  constructor(private el: ElementRef,
    private notifyService: NotificationService,
    private router: Router,
    private otherService: OtherService,
    private mapService: MapService,
    private route: ActivatedRoute,
    private _location: Location,
    private gurdService: GurdServiceService

    ) {}
  ngOnInit(): void {
    setTimeout(() => {
        this.newOpenMap();
        this.route.params.subscribe(params => {
          this.Id=params['id'] 
          this.getCar();
      })
      }, 1000);
      setTimeout(() => {
        this.map.on('click', (e: any) => {
          if (e.dragging) {
            //...
            return;
          }
          setTimeout(() => {
            var el = this.mapService.mapPointerMove(
              this.map.getEventPixel(e.originalEvent),
              this.map
            );
            this.showData(el);
            
          }, 50);
        });
        this.map.getView().on('propertychange', function (e: any) {
          var tooltip = $('#map_tooltip');
          tooltip.tooltip('hide');
        });
      }, 1500);
  }
  newOpenMap() {
    this.map = new Map({
      interactions: defaultInteractions().extend([new DragRotateAndZoom()]),
      target: 'test',
      layers: [
        new TileLayer({
          source: new OSM({}),
        }),
      ],
      view: new View({
        center: olProj.fromLonLat([51.3833554, 35.6770113]),
        zoom: 12,
      }),
    });

    //context menu
  }
  getCar = async () => {
    var model = {
      ID: this.gurdService.decrypt(localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
    };
    const resp = await axios.post(
      `GetCar?strUnitID=${this.Id}`,
      model
    );

    if (resp.data.ISSessionExpired == true) {
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '102' } });

      return;
    }
    if (resp.data == null) {
      this.notifyService.showError('بروز خطا در سامانه');
      return;
    }
 else {
    
        var marker = this.mapService.createMarker(
          [resp.data.fLon, resp.data.fLat],
          'data:image/jpeg;base64,' + resp.data.strMobileIcon,
          `${1}`,
          `${resp.data.strFullName}`,
          {
            html: `
            <h5 class='text-dark'>${resp.data.strFullName} (${resp.data.strMobileType_strComment}) </h5>
            <hr class='text-dark m-1' />
            <div class='justify-content-end d-flex align-items-center'>
              <span class=" text-secondary ms-1"> ${resp.data.fKm } کیلو متر</span>
            <i class="fa fa-user-circle text-secondary "></i>
            </div>
            <div class='justify-content-end d-flex align-items-center'>
            <span class=" text-secondary ms-1">${resp.data.strVehicleNo }</span>
          <i class="fa fa-user-circle text-secondary "></i>
          </div>
          <div class='justify-content-end d-flex align-items-center'>
          <span class=" text-secondary ms-1">${resp.data.strTime }</span>
        <i class="fa fa-user-circle text-secondary "></i>
        </div>
        <div class='justify-content-end d-flex align-items-center'>
        <span class=" text-secondary ms-1">${resp.data.strDate }</span>
      <i class="fa fa-user-circle text-secondary "></i>
      </div>
      <div class='justify-content-end d-flex align-items-center'>
      <span class=" text-secondary ms-1">${ resp.data.bonline==true?resp.data.bonline='روشن':resp.data.bonline='خاموش' }</span>
    <i class="fa fa-user-circle text-secondary "></i>
    </div>
    <div class='justify-content-end d-flex align-items-center'>
    <span class=" text-secondary ms-1">${ resp.data.bACC==true?resp.data.bACC='باز':resp.data.bACC='بسته' }</span>
  <i class="fa fa-user-circle text-secondary "></i>
  </div>
      `,
          }
        );
        this.map.addLayer(marker);
     
      this.car = resp.data;
      this.fitMap(this.car);
    }
  };
  fitMap(data?: any) {
    if (data == null) {
      data = this.car;
    }
      var maxLatitude = data.fLat

      var maxLongitude = data.fLon;
        
      var minLatitude = data.fLat;
      var minLongitude = data.fLon;

      var view = this.map.getView();

      var transformedStart = this.mapService.transformCoordinates2([
        maxLongitude,
        maxLatitude,
      ]);
      var transformedEnd = this.mapService.transformCoordinates2([
        minLongitude,
        minLatitude,
      ]);

      var source = [
        Math.min(transformedStart[0], transformedEnd[0]) - 300,
        Math.min(transformedStart[1], transformedEnd[1]) - 300,
        Math.max(transformedStart[0], transformedEnd[0]) + 300,
        Math.max(transformedStart[1], transformedEnd[1]) + 300,
        // Math.min(transformedStart[0], transformedEnd[0]) - 2000,
        // Math.min(transformedStart[1], transformedEnd[1]) - 2000,
        // Math.max(transformedStart[0], transformedEnd[0]) + 2000,
        // Math.max(transformedStart[1], transformedEnd[1] + 2000)
      ];
      view.fit(source);
    
  }
  showData(item: any) {
    var tooltip = $('#map_tooltip');
    tooltip.tooltip({
      html: true,
      animation: true,
      trigger: 'manual',
      placement:'top',
    });
    tooltip.css({
      left: item.pixel[0] + 'px',
      top: item.pixel[1] - 14 + 'px',
      zindex: 1000,
    });
    if (item.featureLayer) {
      if (item.featureLayer.feature) {
        tooltip
          .attr(
            'data-bs-original-title',
            item.featureLayer.feature.get('data').html
          )
          .tooltip('show');
      }
    } else {
      tooltip.tooltip('hide');
    }
  }
  goBack() {
    this._location.back();
  }
  ngOnDestroy(): void {
    var tooltip = $('#map_tooltip');
          tooltip.tooltip('hide');
  
  }
}
